import { useState } from "react";
import PropTypes from 'prop-types';
import CodeMirror, { EditorView } from '@uiw/react-codemirror';
import { json, jsonParseLinter } from '@codemirror/lang-json';
import { linter, lintGutter } from "@codemirror/lint";
import { Button } from "../Button/Button";
import { Icon } from "../Icon/Icon";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
(function () {
  if (typeof document === "undefined") {
    return;
  }
  const styles = ".kof-code {\n  position: relative;\n}\n.kof-code .copy-to-clipboard {\n  position: absolute;\n  z-index: 1;\n  top: 8px;\n  right: 24px;\n}\n.kof-code.read-only .cm-editor {\n  background: #f9f9f9;\n}";
  const fileName = "Code_Code_4387b4c3-1667-45a3-83fd-9639c0293546";
  const element = document.querySelector("style[data-sass-component='Code_Code_4387b4c3-1667-45a3-83fd-9639c0293546']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function Code({
  type,
  onChange,
  value,
  height = '400px',
  readOnly = false
}) {
  const [wasCopiedToClipboard, setWasCopiedToClipboard] = useState(false);
  const classNames = ['kof-code', readOnly ? 'read-only' : null];
  const baseExtensions = [EditorView.lineWrapping, lintGutter()];
  const typeExtensionsMapping = {
    json: baseExtensions.concat([json(), !readOnly ? linter(jsonParseLinter()) : null].filter(value => value))
  };
  const basicOptions = {
    highlightActiveLineGutter: false,
    highlightActiveLine: !readOnly
  };
  const onChangeInternal = newValue => {
    setWasCopiedToClipboard(false);
    onChange(newValue);
  };

  // delayed, to feel that something happened, especially on re-click
  const delayedCopyToClipboard = () => {
    setWasCopiedToClipboard(false); // for re-click
    setTimeout(() => {
      navigator.clipboard.writeText(value);
      setWasCopiedToClipboard(true);
    }, 50);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: classNames.join(' '),
    children: [/*#__PURE__*/_jsxs(Button, {
      className: "copy-to-clipboard",
      type: 'secondary',
      onClick: delayedCopyToClipboard,
      children: [wasCopiedToClipboard && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Icon, {
          type: 'success'
        }), "\xA0"]
      }), /*#__PURE__*/_jsx(Icon, {
        type: 'copy'
      })]
    }), /*#__PURE__*/_jsx(CodeMirror, {
      basicSetup: basicOptions,
      value: value,
      height: height,
      extensions: [typeExtensionsMapping[type]],
      onChange: onChangeInternal,
      editable: !readOnly
    })]
  });
}
Code.propTypes = {
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
  height: PropTypes.string,
  readOnly: PropTypes.bool
};
export { Code };